import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-0eafeccf"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    style: {
      "height": "100vh"
    }
  }, null, -1);
});

var _hoisted_2 = {
  key: 1,
  class: "app-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_spin = _resolveComponent("a-spin");

  var _component_router_view = _resolveComponent("router-view");

  var _component_a_config_provider = _resolveComponent("a-config-provider");

  return _openBlock(), _createBlock(_component_a_config_provider, {
    locale: _ctx.locale
  }, {
    default: _withCtx(function () {
      return [_ctx.loading ? (_openBlock(), _createBlock(_component_a_spin, {
        key: 0,
        size: "large",
        tip: "正在加载数据中...",
        delay: 500
      }, {
        default: _withCtx(function () {
          return [_hoisted_1];
        }),
        _: 1
      })) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_router_view)]))];
    }),
    _: 1
  }, 8, ["locale"]);
}